import { useEffect, useRef, useState } from "react";

export const ScrollbarPlaceholder = (width) => {
  return <div style={{ width: width, flexShrink: 0 }} />;
};

export const useScrollbarPlaceholderWidth = (tableBodyRef, setColumnWidths) => {
  const firstRender = useRef(true);
  const [scrollbarPlaceholderWidth, setScrollbarWidth] = useState(0);

  // Set scrollbar width if it is present or set it to zero if it's not
  useEffect(() => {
    const ro = new ResizeObserver((entries) => {
      entries.forEach(({ borderBoxSize, contentBoxSize }) => {
        setScrollbarWidth(
          borderBoxSize[0].inlineSize - contentBoxSize[0].inlineSize
        );
      });
    });

    ro.observe(tableBodyRef.current);
  }, []);

  // Update width of last column based on scrollbar presence
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    setColumnWidths((prevColumnWidths) => {
      return prevColumnWidths.map((prevColumnWidth, index) => {
        if (index === prevColumnWidths.length - 1) {
          return scrollbarPlaceholderWidth
            ? prevColumnWidth - scrollbarPlaceholderWidth
            : prevColumnWidth + scrollbarPlaceholderWidth;
        }

        return prevColumnWidth;
      });
    });
  }, [scrollbarPlaceholderWidth, setColumnWidths]);

  return { scrollbarPlaceholderWidth };
};
